import { Grid2 as Grid, Link, Stack, Typography } from '@mui/material';
import { format } from 'date-fns';
import { cs } from 'date-fns/locale';
import { isEmpty } from 'lodash';
import React from 'react';
import { PATHS } from '../../paths';
import { TransparentChip } from '../common';
import { CarRental } from '../types/rental';

interface RentalItemProps extends CarRental {
  extra?: React.ReactNode;
  onClick?: () => void;
}

export const RentalItem = ({
  rentalDate,
  returnDate,
  user,
  car,
  extra,
  onClick,
  accident,
  isReturned,
  isBlocked,
  isExpired,
  isRunning,
  reservationDate
}: RentalItemProps) => (
  <Grid container spacing={2} alignItems="center" width={1} position="relative">
    <Grid size={{ xs: 6, md: 2 }}>
      <Typography fontWeight={600} fontSize="14px" sx={{ fontVariantNumeric: 'tabular-nums' }}>
        {rentalDate ? format(rentalDate, 'EE dd.MM.yyyy', { locale: cs }) : 'N/A'}
      </Typography>
      <Typography color="text.secondary" fontSize="14px" sx={{ fontVariantNumeric: 'tabular-nums' }}>
        {returnDate && format(returnDate, 'EE dd.MM.yyyy', { locale: cs })}
      </Typography>
    </Grid>
    <Grid size={{ xs: 6, md: 2 }}>
      <Stack gap={0.5} alignItems="flex-start">
        {isReturned && <TransparentChip size="small" label="Dokončeno" color="success" variant="filled" />}

        {isBlocked && (
          <Stack gap={1}>
            <TransparentChip size="small" label="Blokovaná" color="warning" variant="filled" />
            {reservationDate && (
              <TransparentChip
                size="small"
                label={`Do: ${format(reservationDate, 'dd.MM.yyyy HH:mm')}`}
                color="default"
                variant="outlined"
              />
            )}
          </Stack>
        )}
        {isRunning && <TransparentChip size="small" label="Probíhající" color="info" variant="filled" />}
        {isExpired && <TransparentChip size="small" label="Neukončená" color="warning" variant="filled" />}
      </Stack>
    </Grid>
    <Grid size={{ xs: 12, md: 4, xl: 5 }}>
      <Stack direction="row" alignItems="center" gap={1}>
        <Typography fontWeight={600} sx={{ cursor: 'pointer' }} onClick={onClick}>
          {user
            ? [user.company?.companyName, [user.surname, user.name].filter(Boolean).join(' ')].filter(Boolean).join(' ')
            : ''}
        </Typography>
        {accident?.id && <Typography component="span">/</Typography>}
        <Link href={PATHS.ACCIDENTS(accident?.id)}>{accident?.contractNumber}</Link>
      </Stack>
      <Typography fontSize="13px" color="text.secondary">
        {car &&
          !isEmpty(car) &&
          [[car?.brand, car?.model].filter(Boolean).join(' '), [car?.plateNumber].filter(Boolean).join(' | ')].join(
            ' | '
          )}
      </Typography>
    </Grid>
    <Grid size={{ xs: 12, md: 3, xl: 3 }} textAlign={{ md: 'end' }}>
      {extra}
    </Grid>
  </Grid>
);
